import { render, staticRenderFns } from "./FunctionalAssessment.vue?vue&type=template&id=6f15064d&scoped=true"
import script from "./FunctionalAssessment.vue?vue&type=script&lang=ts"
export * from "./FunctionalAssessment.vue?vue&type=script&lang=ts"
import style0 from "./FunctionalAssessment.vue?vue&type=style&index=0&id=6f15064d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f15064d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f15064d')) {
      api.createRecord('6f15064d', component.options)
    } else {
      api.reload('6f15064d', component.options)
    }
    module.hot.accept("./FunctionalAssessment.vue?vue&type=template&id=6f15064d&scoped=true", function () {
      api.rerender('6f15064d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/ClientRightSide/FunctionalAssessment.vue"
export default component.exports